import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom' 
import Header from "../Component/Header";
const SchoolVideos = () => {
    useEffect(() => {
        document.title = 'School Videos -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  About Us</li>
                 <li>School Videos</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> School Videos </h1>
                    </div>
                </div>
                <div className="row">
                <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
                 <div class="video-gallery">
                     <a href="https://webapi.entab.info/api/image/TAFS/public/video/video1.mp4" target="_blank">
                        <div class="lazyload-wrapper "> 
                          <img src="https://webapi.entab.info/api/image/TAFS/public/Images/videoimg1.PNG" alt="Gallery Placeholder" class="img-fluid"/>
                          </div> 
                          <div>
                            <h3> Library </h3> 
                        </div>
                        </a>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
                 <div class="video-gallery">
                     <a href="https://webapi.entab.info/api/image/TAFS/public/video/video2.mp4" target="_blank">
                        <div class="lazyload-wrapper "> 
                          <img src="https://webapi.entab.info/api/image/TAFS/public/Images/videoimg2.PNG" alt="Gallery Placeholder" class="img-fluid"/>
                          </div> 
                          <div>
                            <h3> Biology Lab </h3> 
                        </div>
                        </a>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
                 <div class="video-gallery">
                     <a href="https://webapi.entab.info/api/image/TAFS/public/video/video3.mp4" target="_blank">
                        <div class="lazyload-wrapper "> 
                          <img src="https://webapi.entab.info/api/image/TAFS/public/Images/videoimg3.PNG" alt="Gallery Placeholder" class="img-fluid"/>
                          </div> 
                          <div><h3>Chronicles </h3></div>
                        </a>
                    </div>
                </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default SchoolVideos